/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: JackpotBottomBand.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  17.05.23 4:58 pm.
 * Last modified: 17.05.23 4:58 pm.
 *
 * More information at: https://egt-digital.com/
 */

import React, { useEffect, useRef } from 'react';
import store from '../eventStore';
import { useCustomInView } from '../hooks/useCustomInView';
import { IJackpotLabelProps } from './JackpotLabel';

const JackpotBottomBand = ({ jackpotName, denomination, currency }: IJackpotLabelProps) => {
    const [jackpotRef, isVisible] = useCustomInView();
    const ref = useRef<HTMLSpanElement>(null);
    const intervalId = useRef<any>(null);

    const animateJackpotValue = () => {
        if (ref.current) {
            const value = store.JACKPOT_STATS_COUNTER.value;
            const currentValueText = ref.current.innerText;
            let jpObj = value?.get(jackpotName);

            // TODO:: DELETE THIS BEFORE MERGING IN PRODUCTION !!!!!!!!!!!!!!!!!!!
            if (jackpotName === 'InstantLink') {
                jpObj = {
                    jackpotName: 'InstantLink',
                    minDenomination: 40,
                    denominations: new Map([
                        [
                            40,
                            [
                                {
                                    level: 1,
                                    value: 1000009,
                                    formattedValue: '10 000.09',
                                    lastWinValue: 10,
                                    formattedLastWinValue: '10.00',
                                    maxWinValue: 10,
                                    formattedMaxWinValue: '10.00',
                                    lastWinDate: new Date(`2024-02-06T15:07:55.860Z`),
                                    maxWinDate: new Date('2024-02-06T15:07:55.860Z'),
                                    totalWins: 1,
                                },
                            ],
                        ],
                    ]),
                    currency: 'EGT',
                    currencies: ['BGN', 'EUR', 'EGT'],
                };
            }
            let denomObj = jpObj?.denominations.get(denomination);
            if (!denomObj) {
                denomObj = jpObj?.denominations.get(jpObj.minDenomination);
            }
            const nextValueText = denomObj?.sort((a, b) => b.value - a.value)[0].formattedValue || '';
            if (currentValueText !== nextValueText) {
                ref.current.innerText = nextValueText;
            }
            intervalId.current = requestAnimationFrame(animateJackpotValue);
        }
    };

    useEffect(() => {
        if (isVisible && !intervalId.current) {
            intervalId.current = requestAnimationFrame(animateJackpotValue);
        } else if (!isVisible && intervalId.current) {
            cancelAnimationFrame(intervalId.current);
            intervalId.current = null;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isVisible]);

    return (
        <div
            className={
                'egt_game_jackpot_bottom_band ' +
                'jackpot_game_label_' +
                jackpotName
                    .split(' ')
                    .join('_')
                    .toLowerCase()
            }
            ref={jackpotRef}
        >
            <span ref={ref}></span>
            <span className="currency">{currency}</span>
        </div>
    );
};

export default JackpotBottomBand;
